<template>
  <v-row>
    <v-col class="left-side" cols="1" md="1">
      <v-btn class="btn-add-category" @click.native.stop="resetPhone(true)">
        <img src="@/assets/img/plus-icon.png" alt="icon">
      </v-btn>
      <v-dialog v-model="phoneDialog" max-width="600">
        <v-card class="modal modal-phone">
          <div class="modal-head">
            {{ $t('Добавление') }}
            <v-btn color="modal-close" @click.native="resetPhone(false)">
              <img src="@/assets/img/close-icon.png" alt="icon">
            </v-btn>
          </div>
          <div class="modal-body">
            <div class="tab-main">
              <v-form
                ref="form"
                lazy-validation
                @submit.prevent="addPhone"
              >
                <v-row>
                  <v-col cols="4" md="4" class="input-label">
                    <v-label>
                      {{ $t('Телефон') }}: <span class="asterix">*</span>
                      <fieldInfo :info="$t('Телефон')"/>
                    </v-label>
                  </v-col>
                  <v-col class="input-field">
                    <phone-mask-input
                      input-class="input-mask"
                      v-model="phone.text"
                      autoDetectCountry
                      defaultCountry="kg"
                      wrapperClass="input-mask-wrap"
                      showFlag
                    />
                  </v-col>
                </v-row>
                <div class="form-action">
                  <button
                    class="btn btn-default blue"
                    type="submit"
                  >
                    {{ $t('Сохранить') }}
                  </button>
                  <button
                    class="btn btn-default gray"
                    type="button"
                    @click="resetPhone(false)"
                  >
                    {{ $t('Отмена') }}
                  </button>
                </div>
              </v-form>
            </div>
          </div>
        </v-card>
      </v-dialog>
    </v-col>
    <v-col class="right-side">
      <div class="tags">
        <span class="tag" v-bind:key="phone.text" v-for="phone in phones">
          {{ phone.text }}
          <span class="pro-icon-close" @click="deletePhoneList(phone.text)">
            <v-icon>close</v-icon>
          </span>
        </span>
      </div>
    </v-col>
  </v-row>
</template>

<script>
import fieldInfo from '@/components/app/fieldInfo'
import PhoneMaskInput from 'vue-phone-mask-input'

export default {
  components: {
    fieldInfo,
    PhoneMaskInput
  },
  props: {
    phones: Array
  },
  computed: {
    listLocal: {
      get () {
        return this.phones
      },
      set (newList) {
        this.$emit('update:phones', newList)
      }
    }
  },
  data: () => ({
    valid: true,
    phoneDialog: false,
    phone: {}
  }),
  methods: {
    // Обновление формы для добавления
    resetPhone (flag) {
      this.phoneDialog = flag
      this.phone = {}
    },
    // Добавление номера
    addPhone () {
      if (!this.phones.find(x => x.text === this.phone.text)) {
        this.phones.push(this.phone)
        this.resetPhone(false)
      } else {
        this.$noty.warning(this.$i18n.t('Данный номер телефона уже добавлен'), {
          killer: true,
          timeout: 1000,
          layout: 'topRight'
        })
      }
    },
    // Удаление номера
    deletePhoneList (id) {
      if (confirm(this.$i18n.t('Вы действительно хотите выполнить данное действие?'))) {
        this.listLocal = this.listLocal.filter(p => p.text !== id)
      }
    }
  }
}
</script>

<style scoped>

</style>
